import { Pipe, PipeTransform } from '@angular/core';

import { atividadeTipos } from '../atividade-tipo';

@Pipe({
    name: 'atividadeTipoMotivoConclusaoBloqueada'
})
export class AtividadeTipoMotivoConclusaoBloqueadaPipe implements PipeTransform {
    transform(value: number): string {
        if (!value) {
            return '';
        }

        const index = atividadeTipos.findIndex(tipo => tipo.id === value);
        if (index > -1) {
            return atividadeTipos[index].motivoConclusaoBloqueada;
        }
        return '';
    }
}
